import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { Box, TextField } from '@mui/material'
import { Connection } from 'features/connections'
import DocLink from 'features/common/ui/utils/DocLink'
import { DATA_OBSERVATORY_DOCS } from 'app/constants/urls'

interface DataObservatoryFormProps {
  form: Omit<UseFormReturn, 'handleSubmit' | 'formState'>
  connection?: Connection
}

const dataObservatoryName = 'doLocation'
function DataObservatoryLocationForm({ form, connection }: DataObservatoryFormProps) {
  const { register, trigger, setValue, getFieldState } = form
  const [dataObservatory, _setDataObservatory] = useState<string>('')
  const error = getFieldState(dataObservatoryName).invalid
  const isEditing = Boolean(connection?.id)
  const required = isEditing
  const setDataObservatory = useCallback(
    (value) => {
      _setDataObservatory(value)
      setValue(dataObservatoryName, value, { shouldDirty: true })
      trigger(dataObservatoryName)
    },
    [setValue, _setDataObservatory, trigger]
  )

  useEffect(() => {
    if (isEditing) {
      _setDataObservatory(connection?.doLocation || '')
      setValue(dataObservatoryName, connection?.doLocation || '')
      trigger(dataObservatoryName)
    }
  }, [connection?.doLocation, isEditing, setDataObservatory, setValue, trigger])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDataObservatory(e.target.value)
  }

  return (
    <>
      <input type="hidden" value={dataObservatory} {...register(dataObservatoryName, { required })} />
      <Box mt={2}>
        <TextField
          id={dataObservatoryName}
          size="small"
          error={!!error}
          value={dataObservatory}
          required={required}
          onChange={handleChange}
          label={<FormattedMessage id="connections.create.advanced.doLocation.title" />}
          helperText={
            <FormattedMessage
              id="connections.create.advanced.doLocation.description"
              values={{
                a: (content: string) => <DocLink docUrl={DATA_OBSERVATORY_DOCS}>{content}</DocLink>
              }}
            />
          }
        />
      </Box>
    </>
  )
}

export default DataObservatoryLocationForm
